<div id='app-details-version'>
  <div class='inline-child'>SeaLadder Pty. Ltd. ©2026</div>
  <div class='inline-child'>Version: {{version}}</div>
  <div class='inline-child'>
    <i class="db-connected-icon fa fa-check-circle" *ngIf="dbConnected"></i>
    <i class="db-disconnected-icon fa fa-times" *ngIf="!dbConnected"></i>
  </div>
  <div class="terms"><a href="terms">Terms of use</a></div>
</div>
